import React, { useState } from 'react';
import { Fab, SpeedDial, SpeedDialIcon, SpeedDialAction } from '@mui/material';
import ChatIcon from '@mui/icons-material/Chat';
import Brightness4Icon from '@mui/icons-material/Brightness4';
import Brightness7Icon from '@mui/icons-material/Brightness7';
import ChatBot from '../../pages/admin/chatbot';


const FloatingActions = ({ themeMode, toggleTheme, chatOpen, setChatOpen }) => {
  const [open, setOpen] = useState(false);
  const [showChat, setShowChat] = useState(false);

  const actions = [
    { icon: <ChatIcon />, name: 'Chat', action: () => setShowChat(true) },
    { 
      icon: themeMode === "light" ? <Brightness4Icon /> : <Brightness7Icon />, 
      name: 'Cambiar Tema', 
      action: toggleTheme 
    },
  ];

  return (
    <div>
      <SpeedDial
        ariaLabel="Opciones flotantes"
        sx={{ position: 'fixed', bottom: 16, right: 16, zIndex: 9999 }}
        icon={<SpeedDialIcon />}
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
      >
       
        <SpeedDialAction
        icon={<Brightness4Icon />}
        tooltipTitle="Cambiar tema"
        onClick={toggleTheme}
      />
      <SpeedDialAction
        icon={<ChatIcon />}
        tooltipTitle="Abrir Chat"
        onClick={() => setChatOpen(!chatOpen)}
      />
      </SpeedDial>

    </div>
  );
}

export default FloatingActions;
